export const eventTypes = [
	{ value:'assemblea', label:'Assemblea'}
]

export const participantStates = [
	// { value:'active', label:'Attivi (nuovi e approvati)' },
	{ value:'new', label:'Nuovo' },
	{ value:'approved', label:'Approvato' },
	{ value:'refused', label:'Rifiutato' },
]

export const referenceOptions = [
	{ value:'brescia', label:'BRESCIA' },
	{ value:'leno', label:'LENO' },
	{ value:'montichiari', label:'MONTICHIARI' },
	{ value:'verolanuova', label:'VEROLANUOVA' },
	{ value:'chiari', label:'CHIARI' },
	{ value:'orzinuovi', label:'ORZINUOVI' },
	{ value:'lonato', label:'LONATO' },
	{ value:'darfo', label:'DARFO' },
	{ value:'autorità', label:'Autorità' },
	{ value:'anga', label:'Anga' },
	{ value:'latte', label:'Latte' },
	// { value:'sponsor', label:'Sponsor' },
	{ value:'presidente', label:'Presidente' },
	{ value:'dipendente', label:'Dipendente' },
	{ value:'stampa', label:'Stampa' },
	{ value:'consiglio', label:'Consiglio' },
	{ value:'comuni', label:'Comuni' },
	// { value:'associazione', label:'Associazione' },
	{ value:'altre-confagri', label:'Altre Confagricoltura' },
	{ value:'ospiti', label:'OSPITI' },
	{ value:'altro', label:'ALTRO' },
	{ value:'vino', label:'VINO' },
]
export const attendOptions = [
	{ value:'assembly', label: 'ASSEMBLEA' },
	{ value:'all', label: 'ASSEMBLEA + CENA' },
]
export const menuOptions = [
	{ value:'meat', label: 'SPIEDO' },
	{ value:'veg', label: 'PIATTO VEGETARIANO' },
]
export const scanOptions = [
	{ value:'done', label: 'Scansionato' },
	{ value:'missing', label: 'Non scansionato' },
]
